import React, { useContext, useState } from "react";
import { AppContext } from "../../../../appContext";
import { PopupWrapper } from "../../../../components/styled/BasicBlocks";
import { SideMenuCommonHeader } from "./SideMenuCommon";
import { ISideMenuRouteProps } from "./ISideMenuRouteProps";
import { getWallpapersPreviews, getWallpaperPreviewByKey } from "../../../../utils/wallpapers";
import { getTimezoneOptions, getUserTimezone, setUserTimezone, getAutoDetectedTimezone } from "../../../../utils/timezone";
import defaultBg from "../../../../assets/login/background.png";
import "./SideMenuSettings.css";

const previews = getWallpapersPreviews();

export const SideMenuSettings = ({onClose}: ISideMenuRouteProps) => {
    const {fontScaler, setFontScaler} = useContext(AppContext);
    const {wallpaper, setWallpaper} = useContext(AppContext);
    const {translate} = useContext(AppContext);
    const {userTimezone, setUserTimezone} = useContext(AppContext);
    
    // Timezone options
    const timezoneOptions = getTimezoneOptions(translate);

    const handleTimezoneChange = (timezone: string) => {
        setUserTimezone(timezone);
    };

    const handleClose = ()=>{
        onClose();
    }
    return <PopupWrapper className="SideMenuSettings">
        <SideMenuCommonHeader text={translate('sideMenu_settings')} onClose={handleClose}></SideMenuCommonHeader>
        <div>
            <div>{translate('sideMenuSettings_fontSize')}:</div>
            <input type="range" min="0.6" value={fontScaler} step={0.02} max={1.4} onChange={(e)=>{
                setFontScaler(e.target.valueAsNumber);
            }}></input>

            <div>{translate('sideMenuSettings_timezone')}:</div>
            <div className="SideMenuSettings_timezone">
                <select 
                    value={userTimezone} 
                    onChange={(e) => handleTimezoneChange(e.target.value)}
                    className="SideMenuSettings_timezoneSelect"
                >
                    {timezoneOptions.map(option => (
                        <option key={option.id} value={option.id}>
                            {option.name}
                        </option>
                    ))}
                </select>
            </div>

            <div>{translate('Desktop background')}
            </div>
            <div className="SideMenuSettings_wallpapers">
                {//['', ...previews].map(img=>{
                previews.map(img=>{
                    return <div 
                        className={`SideMenuSettings_wallpaper_preview ${img == wallpaper ? 'SideMenuSettings_wallpaper_preview--selected':''}`} 
                        //style={{backgroundImage: img == '' ? `url(${defaultBg})` : `url(${getWallpaperPreviewByKey(img)})`}}
                        style={{backgroundImage: `url(${getWallpaperPreviewByKey(img)})`}}
                        onClick={()=>(setWallpaper(img))}
                    >
                        {img}
                    </div>
                })}
            </div>
        </div>
    </PopupWrapper>
}